module.exports = __webpack_public_path__ + "7b6765cd.png";


//////////////////
// WEBPACK FOOTER
// ./src/routes/home/img/slide4.png
// module id = 685
// module chunks = 1